var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amui-lazy-image"},[_c('img',{attrs:{"fetchpriority":_vm.fetchPriority,"draggable":"false","src":_vm.computedSource,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }